export default __webpack_public_path__ + "static/media/strava.3c5d44f1.svg";